import React, { useState } from 'react';
import { Box, Button, Avatar, IconButton, Tooltip, Menu, MenuItem, Divider, ListItemIcon, ListItemText, Typography } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { AuthService, authManager } from '@df/api';
import { useNavigate } from 'react-router-dom';
// Logo removed - will be added back when needed

const HeaderActions = ({ 
  isAuthenticated = false,
  onLogout = () => {},
  userEmail = '',
  onOpenSettings = () => {},
}) => {
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleUserMenuOpen = (event) => {
    setUserMenuAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserMenuAnchorEl(null);
  };

  const handleLogout = async () => {
    handleUserMenuClose();
    
    try {
      // Get refresh token for logout API call
      const refreshToken = authManager.getRefreshToken();
      
      if (refreshToken) {
        // Call logout API using @df/api
        await AuthService.logout(refreshToken);
      }
    } catch (error) {
      console.error('Logout API call failed:', error);
    } finally {
      // Clear tokens from authManager (in-memory) and redirect
      authManager.clearTokens();
      
      // Redirect to login
      window.location.href = '/login';
    }
  };

  const handleSettings = () => {
    handleUserMenuClose();
    onOpenSettings();
  };

  const handleAccount = () => {
    handleUserMenuClose();
    navigate('/me');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0.5rem 1rem',
        backgroundColor: '#f8f9fa',
        borderBottom: '1px solid #e0e0e0',
        height: '64px',
        boxSizing: 'border-box',
      }}
    >
      {/* Left side - Empty space (logo removed) */}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
      </Box>

      {/* Right side - User Menu */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Tooltip title="User Menu" arrow>
          <IconButton 
            onClick={handleUserMenuOpen}
          >
            <Avatar 
              sx={{ 
                width: 32, 
                height: 32, 
                bgcolor: '#2D5EFF',
                fontSize: '14px',
                fontWeight: 'bold'
              }}
            >
              {userEmail ? userEmail.charAt(0).toUpperCase() : 'U'}
            </Avatar>
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={userMenuAnchorEl}
          open={Boolean(userMenuAnchorEl)}
          onClose={handleUserMenuClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              width: 200,
              mt: 1,
            },
          }}
        >
          {/* User Info */}
          <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid #e0e0e0' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#333' }}>
              {userEmail || 'User'}
            </Typography>
          </Box>
          
          <MenuItem onClick={handleSettings}>
            <ListItemIcon>
              <SettingsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Settings</ListItemText>
          </MenuItem>

          <MenuItem onClick={handleAccount}>
            <ListItemIcon>
              <AccountCircleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Account</ListItemText>
          </MenuItem>
          
          <Divider />
          
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Sign Out</ListItemText>
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default HeaderActions; 
